const cached = {};

const keys = {};

const moment = window['moment'];

const expiryTime = 30;
const expiryBy = 'seconds';
const disable = false;

function setStore(key, value) {
  return !disable && sessionStorage.setItem(key, JSON.stringify(value));
}

function getStore(key) {
  const value = sessionStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
}

const _isExpired = function (key) {
  key = `expiry-${key}`;

  let expired = false;
  const storedExpiry = getStore(key);

  if (storedExpiry != null) {
    const expiration = moment(storedExpiry);
    if (moment().isAfter(expiration)) {
      setStore(key, null);
      expired = true;
    }
  }

  if (storedExpiry == null) {
    expired = true;
  }

  return expired;
};

const _setExpiry = function (key, expiryTime) {
  key = `expiry-${key}`;

  const expiry = moment()
    .add(expiryTime, expiryBy)
    .format('YYYY-MM-DD HH:mm:ss');

  setStore(key, expiry);

  return keys[key];
};

const _cache = function cache(key, value?) {
  if (value != undefined) {
    setStore(key, value);
    return value;
  }
  return getStore(key);
};

type CacheServiceConfigType = { expiry: number };

const CacheService = (key, query, config?) => {
  if (!config) {
    config = {} as CacheServiceConfigType;
  }

  const expiry = config.expiry || expiryTime;
  const isExpired = _isExpired(key);

  if (!isExpired) {
    return _cache(key);
  }
  return query().then(res => {
    _cache(key, res);
    _setExpiry(key, expiry);
    return res;
  });
};

window['cached_responses'] = cached;
window['cached_responses_expiration'] = keys;

export default CacheService;
